<div>
  <h1>Правила дорожного движения 2026 статьи пдд</h1>
</div>
<div>
  <ul class="list_category">
    <ng-container *ngFor="let theme of this.PddService.pdd; let  i = index">
      <li>
        <a [routerLink]="['/', 'pdd-'+theme.url]">
          <div class="sb-num">
            {{ i + 1 }}
          </div>
          <div>
            {{ theme.title }}
          </div>
        </a>
      </li>
    </ng-container>
  </ul>
</div>
